<template>
  <div>
    <div class="mb-3">
      <hr>
      <table class="tablaBusqueda">
        <tr>
          <td><label for="nombre" class="form-label">Nombre</label></td>
          <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda"
              style="width: 500px; text-transform:uppercase;" required></td>
          <td class="centro">
            <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
              <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
            </button>
          </td>
          <td class="centro">
            <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)"
              title="Todos los registros">
              <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
            </button>
          </td>
        </tr>
      </table>
    </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Nombre</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="archivopla in datosPaginados" :key="archivopla.idArchivoPla">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;"
              @click="abrirModalEditar(archivopla.idArchivoPla)" title="Editar">edit_square</i></td>
          <td><a :href="transformarRutaEnURL(archivopla.nombre)" target="_blank">{{ archivopla.nombre }}</a></td>
          <td style="text-align: right;">
            <button @click="openModal" class="btn btn-outline-danger">Abrir PDF</button>
            <file-viewer :fileUrl="transformarRutaEnURL(archivopla.nombre)" v-model:visible="isModalVisible" />
          </td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;"
              @click="deleteArchivoPla(archivopla.idArchivoPla)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click="getDataPagina(pagina)"
          class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{ pagina }}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
    <!-- Modal -->
    <div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"
      v-if="modalWindow">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="exampleModalLabel">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
            </button>
          </div>
          <form>
            <div class="modal-body">

              <!-- Identificación -->
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-3">
                    <label class="form-label fw-bold">ID Archivo</label>
                  </div>
                  <div class="col-9">
                    <span>{{ datoArchivoPla.idArchivoPla }}</span>
                  </div>
                </div>
              </div>

              <!-- Información del archivo -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-3">
                    <label class="form-label fw-bold">Nombre</label>
                  </div>
                  <div class="col-9">
                    <span>{{ datoArchivoPla.nombre }}</span>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-3">
                    <label class="form-label fw-bold">Ruta</label>
                  </div>
                  <div class="col-9">
                    <span>{{ datoArchivoPla.ruta }}</span>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-3">
                    <label class="form-label fw-bold">Tipo</label>
                  </div>
                  <div class="col-9">
                    <span>{{ datoArchivoPla.tipo }}</span>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-3">
                    <label class="form-label fw-bold">Tamaño</label>
                  </div>
                  <div class="col-9">
                    <span>{{ datoArchivoPla.tamano }}</span>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-3">
                    <label class="form-label fw-bold">Hash</label>
                  </div>
                  <div class="col-9">
                    <span>{{ datoArchivoPla.hash }}</span>
                  </div>
                </div>
              </div>

              <!-- Fechas -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-3">
                    <label class="form-label fw-bold">Fecha Creación</label>
                  </div>
                  <div class="col-9">
                    <span>{{ datoArchivoPla.fechaCrea }}</span>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-3">
                    <label class="form-label fw-bold">Fecha Modificación</label>
                  </div>
                  <div class="col-9">
                    <span>{{ datoArchivoPla.fechaMod }}</span>
                  </div>
                </div>
              </div>

            </div>
          </form>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FileViewer from '../../components/FileViewer.vue';
import { validarForm } from '../../modules/validacionesForms.js'
import dateFormat from '@/modules/dateFormat.js';
//import { format } from 'date-fns';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from 'sweetalert'
export default {
  props: {
    p_idPlanilla: {
      type: Number,
      required: true
    }
  },
  components: {
    FileViewer
  },
  data() {
    return {
      archivoplas: [],
      datoArchivoPla: {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      planillas: [],
      isModalVisible: false,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  /*
    computed: {
      formattedFechaReg() {
        const originalDate = new Date(this.datoAuto.fechaReg);
        return format(originalDate, 'dd/MM/yyyy');
      },
    },
  */

  mounted() {
    this.getDataPaginaTodos(this.paginaActual)
    //    this.fetchPlanillas()
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas() {
      return Math.ceil(this.archivoplas.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina) {
      if (this.nombreBusqueda != '') {
        api.get('/vwarchivoplas/nombre/' + this.nombreBusqueda).then(response => {
          this.archivoplas = response.data.reverse();
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.archivoplas.slice(ini, fin);
        });
      }
    },
    getDataPaginaTodos(noPagina) {
      api.get('/vwarchivoplas/idplanilla/' + this.p_idPlanilla).then(response => {
        this.archivoplas = response.data.reverse();
        this.paginaActual = noPagina;
        this.datosPaginados = [];
        let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
        let fin = (noPagina * this.elementosPorPagina);
        this.datosPaginados = this.archivoplas.slice(ini, fin);
      });
    },
    getPreviousPage() {
      if (this.paginaActual > 1) {
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) {
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina) {
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm() {
      const requiredFields = [
        'idPlanilla'
        , 'nombre'
        , 'ruta'
        , 'tipo'
        , 'fechaCrea'
        , 'fechaMod'
        , 'tamano'
        , 'hash'
      ];
      const requiredFieldsText = [
        'idPlanilla'
        , 'nombre'
        , 'ruta'
        , 'tipo'
        , 'fechaCrea'
        , 'fechaMod'
        , 'tamano'
        , 'hash'
      ];
      return validarForm(this.datoArchivoPla, requiredFields, requiredFieldsText);
    },
    async guardarArchivoPla() {
      if (this.validarForm() === 1) {
        try {
          await api.post('/archivoplas', this.datoArchivoPla)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "ArchivoPla creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditArchivoPla() {
      if (this.validarForm() === 1) {
        try {
          await api.post('/archivoplas', this.datoArchivoPla)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "ArchivoPla creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalEditar(idArchivoPla) {
      this.modalWindow = true
      if (idArchivoPla != null) {
        api.get('/vwarchivoplas/' + idArchivoPla).then(resp => {
          this.datoArchivoPla = resp.data;
        });
      }
      $('#ventanaModal').modal('show');
      this.titulo = 'Datos del archivo'
      this.btnCrear = false
      this.btnEditar = true
    },
    abrirEditar(idArchivoPla) {
      if (idArchivoPla != null) {
        this.$router.push('/archivoplamd/' + idArchivoPla)
      }
    },
    async deleteArchivoPla(idArchivoPla) {
      try {
        await api.delete('/archivoplas/' + idArchivoPla)
        this.getDataPagina(this.paginaActual);
      } catch (error) {
        alert('No se pudo eliminar')
      }
    },
    openModal() {
      this.isModalVisible = true;
    },
    transformarRutaEnURL(ruta) {
      const baseURL = 'http://localhost:8081/archivos/';
      return baseURL + encodeURIComponent(ruta);
    },
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
